"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const DesktopHeaderSkeleton = () => {
    return (react_1.default.createElement(styles_1.StepperSkeletonContainer, null,
        react_1.default.createElement(styles_1.StepperShimmerCircle, null),
        react_1.default.createElement(styles_1.StepperShimmerSquare, null),
        react_1.default.createElement(styles_1.StepperShimmerLine, null),
        react_1.default.createElement(styles_1.StepperShimmerCircle, null),
        react_1.default.createElement(styles_1.StepperShimmerSquare, null),
        react_1.default.createElement(styles_1.StepperShimmerLine, null),
        react_1.default.createElement(styles_1.StepperShimmerCircle, null),
        react_1.default.createElement(styles_1.StepperShimmerSquare, null)));
};
exports.default = DesktopHeaderSkeleton;
//# sourceMappingURL=DesktopHeaderSkeleton.js.map